import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './MaskedInput.css'

const $ = window.jQuery;

class MaskedInput extends Component {
    static propTypes = {
        mask: PropTypes.string.isRequired,
        onChange: PropTypes.func
    };
    static defaultProps = {};
    state = {};

    componentDidMount() {
        const {mask, value, onChange} = this.props;

        this.$el = $(this.el);
        this.$el.mask(mask, {autoclear: false});
        this.$el.val(value);
        this.$el.on('keyup', onChange);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value)
            this.$el.val(nextProps.value);
    }

    componentWillUnmount() {
        this.$el.unmask();
        this.$el.off('keyup');
    }

    render() {
        const {mask, value, onChange, ...props} = this.props;
        return (
            <input ref={el => this.el = el} {...props} />
        );
    }
}

export default MaskedInput;


// WEBPACK FOOTER //
// ./src/controls/MaskedInput.js